import { render, staticRenderFns } from "./MantenedorCredenciales.vue?vue&type=template&id=52b57c8a"
import script from "./MantenedorCredenciales.vue?vue&type=script&lang=js"
export * from "./MantenedorCredenciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports